import {
  ADS_CAMPAIGN_TYPE_APP_OPTION,
  ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_OPTION,
  ADS_CAMPAIGN_TYPE_SEARCH_OPTION,
  GOOGLE,
  LINKEDIN,
  META,
  TIKTOK,
} from "../../../utils/constants";

const BULK_CAMPAIGN_TYPE_STANDARD = "standard";

const countSummary = (campaigns) => ({
  campaigns: (campaigns ?? []).length,
});

const searchSummary = (campaigns) => ({
  campaigns: (campaigns ?? []).length,
  maxAdGroups: (campaigns ?? []).reduce(
    (max, campaign) => Math.max(max, (campaign?.adGroups ?? []).length),
    0
  ),
});

/**
 * One entry per (platform, campaign type) the backend supports in the bulk
 * flow (mirror of flup-firebase-api bulkCampaigns/registry.js). The modal and
 * the jobs only read from here, so supporting a new type means adding an
 * entry:
 * - usagePlatform: platform used to compute the credit usage.
 * - getSummaryValues: values interpolated in the summary text.
 */
const BULK_CAMPAIGN_TYPES = {
  [`${GOOGLE}:${ADS_CAMPAIGN_TYPE_SEARCH_OPTION}`]: {
    usagePlatform: GOOGLE,
    getSummaryValues: searchSummary,
  },
  [`${GOOGLE}:${ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_OPTION}`]: {
    usagePlatform: GOOGLE,
    getSummaryValues: countSummary,
  },
  [`${GOOGLE}:${ADS_CAMPAIGN_TYPE_APP_OPTION}`]: {
    usagePlatform: GOOGLE,
    getSummaryValues: countSummary,
  },
  [`${META}:${BULK_CAMPAIGN_TYPE_STANDARD}`]: {
    usagePlatform: META,
    getSummaryValues: countSummary,
  },
  [`${TIKTOK}:${BULK_CAMPAIGN_TYPE_STANDARD}`]: {
    usagePlatform: TIKTOK,
    getSummaryValues: countSummary,
  },
  [`${LINKEDIN}:${BULK_CAMPAIGN_TYPE_STANDARD}`]: {
    usagePlatform: LINKEDIN,
    getSummaryValues: countSummary,
  },
};

const KNOWN_USAGE_PLATFORMS = new Set([GOOGLE, META, TIKTOK, LINKEDIN]);

const DEFAULT_CONFIG = {
  usagePlatform: null,
  getSummaryValues: countSummary,
};

export const getBulkCampaignTypeConfig = ({ platform, campaignType } = {}) => {
  const match = BULK_CAMPAIGN_TYPES[`${platform}:${campaignType}`];
  if (match) return match;
  if (KNOWN_USAGE_PLATFORMS.has(platform)) {
    return { usagePlatform: platform, getSummaryValues: countSummary };
  }
  return DEFAULT_CONFIG;
};
